module.exports = __webpack_public_path__ + "img/eduworks-logo.c696b050.svg";